export const GroupIamActionThingTypeMrn = "mrn:sl2:iam::groupIamAction";
